import { formatAspect } from "utils/playground/banner";
import { TBannerItem } from "services/page/admin";
import { WEB_MAXWIDTH, WEB_WIDTH } from "./constants";
import { multilingualImgDisplay, multilingualLinkDisplay } from "utils/mutil-Language";
import { genPrmLink } from "utils/url";
import { TBannerItem as BannerItemProps } from "optimus-front/lib/services/banner";
import { PrmParams } from "utils/prm";

export const transformBannerSize = (banner: TBannerItem, spm: PrmParams): BannerItemProps => {
	const { width, height } = banner;

	let img = multilingualImgDisplay(banner);

	let link = multilingualLinkDisplay(banner);
	link = genPrmLink({ floor: spm?.floor, position: spm?.position }, link);
	const nextSize = formatBannerSize({
		width,
		height,
	});
	return {
		link,
		img,
		width: nextSize.width.toString(),
		height: nextSize.height.toString(),
	};
};
export const transformBannersSize = (banners: TBannerItem[], spm: PrmParams): BannerItemProps[] => {
	return banners.map((banner, idx) => {
		return transformBannerSize(banner, { ...spm, position: idx + 1 });
	});
};

export const formatBannerSize = ({
	width,
	height,
}: {
	width: number | string;
	height: number | string;
}) => {
	const bannerWidth = formatAspect(width || "");
	const bannerHeight = formatAspect(height || "");
	return {
		width: bannerWidth,
		height: bannerHeight,
	};
};
/**
 * 目前只有magic banner适应这种根据图片宽来定格栅width
 * @param bannerWidth
 */
export const fetchBannerGridWidth = (bannerWidth: number) => {
	const nextBannerWidth = bannerWidth > 1440 ? WEB_MAXWIDTH : bannerWidth;
	return Math.max(nextBannerWidth, WEB_WIDTH);
};
